import type { DealExecutionStatus } from '@/store/growl/state/common.ts';

export const getExecutionColorAndIcon = (status: DealExecutionStatus): [color: string, icon: string] => {
  switch (status) {
    case 'integrated':
    case 'confirmed':
    case 'not-integrated':
      return ['success', 'check_circle'];

    case 'pending':
    case 'still-pending':
      return ['warning', 'hourglass_empty'];

    case 'timeout':
      return ['danger', 'highlight_off'];

    case 'rejected':
      return ['danger', 'highlight_off'];

    default:
      console.error('Need to convert execution status to growl color', status);
      return ['info', ''];
  }
};
